import React from 'react';
import { Link } from 'react-router-dom'; // Step 1: Import Link
import './App.css';

const data = [
  {
    image: "./images/china1.jpg",
    title: "Beijing",
    description: "Discover imperial palaces, ancient alleys, and timeless traditions in the heart of China. ",
    link: "/beijing"
  },
  {
      image: "./images/S1.webp",
      title: "Shanghai",
      description: "Skyscrapers, heritage streets, world-class shopping, and unforgettable cuisine. ",
      link: "/shanghai"
    },
  {
    image: "./images/CH2.webp",
    title: "Guangzhou",
    description: "Experience southern charm, cultural treasures, and world-famous Cantonese flavors.",
    link: "/guangzhou"
  },
    {
      image: "./images/xian1.webp",
      title: "Xian",
      description: "Journey into China’s imperial heart — home of dynasties, warriors, and ancient trade.",
      link: "/xian"
    },
      {
        image: "./images/wuhan.webp",
        title: "Wuhan",
        description: " Discover lakeside beauty, cultural heritage, and bold central Chinese flavors.",
        link: "/wuhan"
      },
        {
          image: "./images/chendu.webp",
          title: "Chengdu",
          description: "Discover pandas, ancient Taoist culture, and the bold flavors of Sichuan cuisine.",
          link: "/chengdu"
        },
          {
            image: "./images/zu1.webp",
            title: "Zhangjiajie",
            description: "Witness towering peaks, thrilling glass bridges, and mystical landscapes.",
            link: "/zhangjiajie"
          },
            {
              image: "./images/guilin2.webp",
              title: "Guilin",
              description: "Drift through karst peaks, ancient caves, and serene river valleys.",
              link: "/guilin"
            },
             {
                          image: "./images/han.webp",
                          title: "Hangzhou",
                          description: "Sail across poetic waters, sip fresh tea, and step into timeless Chinese charm.",
                          link: "/hangzhou"
                        },
                         {
                                      image: "./images/habin2.webp",
                                      title: "Harbin",
                                      description: "Stroll icy boulevards, admire snowy cathedrals, and witness glowing ice palaces.",
                                      link: "/harbin"
                                    }



];

const InfoSection = () => {
  return (
    <div className="sri-info-section">
      {/* Heading */}
      <h2 className="sri-section-main-heading">Destinations in China</h2>

      {/* Grid of destination boxes */}
      <div className="sri-box-row2">
        {data.map((item, index) => (
          <div className="sri-info-box2" key={index}>
            <img src={item.image} className="sri-info-image" />
            <div className="sri-info-content">
              <h3 className="sri-info-title">{item.title}</h3>
              <p className="sri-info-description">{item.description}</p>
              <Link to={item.link} className="read-more-button">Read More ...</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoSection;
